import FormsActions from '../formsActions';
import FormsSelectors from '../utils/formsSelectors';
import FormsConfigs from '../formsConfigs/formsConfigs';
import HttpService from '../../../services/httpService';

const timers = {};

const handleFormInit = ({ command, ...params }) => {
  FormsActions.init({
    form: {
      id: command.instanceName,
      instanceName: command.instanceName,
      instanceToken: command.instanceToken,
      parentToken: command.parentToken,
      actions: command.actions,
      fields: command.fields,
      params: command.params || {},
      signSource: params.signSource,
      signInstanceName: params.signInstanceName
    }
  });
};

const handleFormClose = ({ command }) => {
  clearInterval(timers[command.instanceToken]);
  delete timers[command.instanceToken];

  FormsActions.close({
    instanceToken: command.instanceToken
  });
};

const handleFormTimer = ({ command }) => {
  if (command.delay === 0) {
    clearInterval(timers[command.instanceToken]);
    delete timers[command.instanceToken];
    return;
  }

  timers[command.instanceToken] = setInterval(() => {
    FormsActions.apply({
      instanceToken: command.instanceToken,
      actionId: '_onTimer'
    });
  }, command.delay * 1000);
};

const handleStateUpdate = ({ command }) => {
  const form = FormsSelectors.getByToken(command.instanceToken);

  function mapFormFields(fields, fieldsFormConfig) {
    const preparedFields = {};

    Object.keys(fields).forEach(key => {
      const field = fields[key];
      const fieldConfig = fieldsFormConfig[key];

      if (field.type === 'grid' && fieldConfig && fieldConfig.gridConfig) {
        field.items = fieldConfig.gridConfig.map(field.items, fields);
      }

      preparedFields[key] = field;
    });

    return preparedFields;
  }

  if (form) {
    const formConfig = FormsConfigs.getByName(form.instanceName);

    FormsActions.update({
      instanceToken: command.instanceToken,
      fields: mapFormFields(command.fields, formConfig.fields),
      actions: command.actions,
      params: command.params,
      errors: command.errors
    });
  }
};

const handleRedirect = ({ command }) => {
  HttpService.redirect(command.destination);
};

const handleCommand = async ({ command, commands, ...params }) => {
  if (!command) return;

  switch (command.command) {
    case 'formInit':
      handleFormInit({ command, ...params });
      break;
    case 'formClose':
      handleFormClose({ command });
      break;
    case 'stateUpdate':
      handleStateUpdate({ command });
      break;
    case 'scheduleTimer':
      handleFormTimer({ command });
      break;
    case 'redirect':
      handleRedirect({ command });
      break;
    default:
      break;
  }
};

const handle = ({ commands, ...params }) => {
  if (!Array.isArray(commands)) return;

  commands.forEach(command => {
    handleCommand({
      command,
      commands,
      ...params
    });
  });
};

const CommandsHandler = {
  handle
};

export default CommandsHandler;



// WEBPACK FOOTER //
// ./src/store/forms/commands/commandsHandler.js